export enum Pages {
    Login = '/',
    Auth0Callback = '/auth0-callback',
    Logout = '/logout',
    ImportLinkedHelperCsv = '/import',
    Roles = '/roles',
    CreateNewRole = '/create-role',
    UpdateRole = '/edit-role',
    ManageRole = '/manage-role',
    Tenants = '/tenants',
    Tenant = '/tenant',
    CreateNewTenant = '/create-tenant',
    CreateNewUser = '/create-user',
    UpdateUser = '/edit-user',
    AccessDenied = '/access-denied',
    DataManagement = '/data-management',
    CandidateSearchVectorTests = '/candidate-search-vector-tests',
    HelixSearch = '/search',
}
